export default __webpack_public_path__ + "static/screen-homepage-3ce7b36c126578fe31bc2b09b123fb0c.mp4";